import {useContext} from 'react';
import FilterContext, {FilterContextProps} from '@/contexts/filterContext';

const useFilterContext = (): FilterContextProps => {
  const context = useContext(FilterContext);

  if (!context) {
    throw new Error(
      'useFilterContext must be used within an FilterContextProvider',
    );
  }

  return context;
};

export default useFilterContext;
